/* TypeScript file generated from BabyPaintingsPage.res by genType. */

/* eslint-disable */
/* tslint:disable */

import * as BabyPaintingsPageJS from './BabyPaintingsPage.re.mjs';

export type props = {};

export const make: React.ComponentType<{}> = BabyPaintingsPageJS.make as any;

export const $$default: React.ComponentType<{}> = BabyPaintingsPageJS.default as any;

export default $$default;
